import { LUXURY_PLUS_PATHS } from 'luxPlus/constants/base'

export function getCheckoutRouteFromURL(pathname: string): string {
  const split = pathname.split('/').pop() || ''
  return split?.split('?')[0]
}

export function getOnPurchaseSuccessPath(order: App.Order, isLuxPlusEnabled: boolean, orderItemId?: string, postPurchase?: string): string {
  const { itemsCount, id: orderId, subscriptionItems } = order
  const orderItemIdParam = orderItemId ? `&orderItemId=${orderItemId}` : ''
  let postPurchaseParam = ''

  if (postPurchase === 'change-dates' || postPurchase === 'change-package') {
    postPurchaseParam = `&postPurchase=${postPurchase}`
  }

  const DEFAULT_REDIRECT_PATH = `/booking/confirmation?orderId=${orderId}${orderItemIdParam}${postPurchaseParam}`
  const hasSubscriptionItems = subscriptionItems.length > 0

  if (isLuxPlusEnabled && hasSubscriptionItems && itemsCount === subscriptionItems.length) {
    return `/${LUXURY_PLUS_PATHS.ACCOUNT_MANAGEMENT_PAGE}?orderId=${orderId}${orderItemIdParam}${postPurchaseParam}`
  }

  return DEFAULT_REDIRECT_PATH
}
